<template>
  <div class="other-cost-page">
    <div class="workbench">
      <aside class="fee-sidebar">
        <div class="fee-list">
          <div
            v-for="item in feeItems"
            :key="getFeeCardKey(item)"
            class="fee-card"
            :class="{ active: activeFeeKey === getFeeCardKey(item) }"
            @click="selectFeeItem(item)"
          >
            <div class="fee-card-main">
              <h3 class="fee-title-row">{{ $t(QUOTATION_FEE_ITEM.bjGet(item.feeItem)) }}</h3>
              <div class="fee-meta-side centered">
                <!-- 计费类型 -->
                <div class="fee-meta">
                  <span class="meta-label">{{ $t('QuotationCenter.billingType') }}:</span>
                  <el-tag size="mini" type="primary">{{ $t(QUOTATION_BILLING_TYPE.bjGet(item.billingType)) }}</el-tag>
                </div>
                <!-- 计费单位 -->
                <div class="fee-meta">
                  <span class="meta-label">{{ $t('QuotationCenter.chargeUnit') }}:</span>
                  <el-tag size="mini" type="primary">{{ $t(QUOTATION_CHARGE_UNIT.bjGet(item.chargeUnit)) }}</el-tag>
                </div>
                <!-- 计算燃油 -->
                <div class="fee-meta">
                  <span class="meta-label">{{ $t('QuotationCenter.calcFuel') }}:</span>
                  <el-switch :value="Number(item.calcFuel) === 0" disabled />
                </div>
              </div>
            </div>
            <div class="fee-actions">
              <el-button type="text" icon="el-icon-delete" class="danger-text" @click.stop="deleteFeeItem(item)">{{ $t('delText') }}</el-button>
              <el-button type="text" icon="el-icon-edit" @click.stop="openFeeDialog(item)">{{ $t('editText') }}</el-button>
            </div>
          </div>
        </div>

        <div class="add-fee-card" @click="openFeeDialog()">
          <i class="el-icon-plus"></i>
          <span>{{ $t('QuotationCenter.add') }}</span>
        </div>
      </aside>

      <CostEditorPanel :fee-item="activeFeeItem" />
    </div>

    <BjDialog
      :visible.sync="feeDialogVisible"
      :title="formTitle"
      width="500px"
      :close-on-click-modal="false"
      @close="closeFeeDialog"
    >
      <el-form ref="feeForm" :model="feeForm" label-position="top" class="fee-form" :rules="feeFormRules">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('QuotationCenter.feeItem')" prop="feeItem">
              <BjSelectLov v-model="feeForm.feeItem" :placeholder="$t('QuotationCenter.feeItem')" :option-list="feeItemOptions" show-disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('QuotationCenter.billingType')" prop="billingType">
              <BjSelectLov v-model="feeForm.billingType" :placeholder="$t('QuotationCenter.billingType')" :option-list="QUOTATION_BILLING_TYPE" @change="handleBillingTypeChange" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('QuotationCenter.chargeUnit')" prop="chargeUnit">
              <BjSelectLov v-model="feeForm.chargeUnit" :placeholder="$t('QuotationCenter.chargeUnit')" :option-list="QUOTATION_CHARGE_UNIT" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('QuotationCenter.calcFuel')" prop="calcFuel">
              <BjSelectLov v-model="feeForm.calcFuel" :placeholder="$t('QuotationCenter.calcFuel')" :option-list="QUOTATION_CALC_FUEL" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template slot="footer">
        <el-button @click="closeFeeDialog">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="confirmFeeDialog">{{ $t('okText') }}</el-button>
      </template>
    </BjDialog>
  </div>
</template>

<script>
import { logisticApi } from '@/api';
import {
  QUOTATION_FEE_ITEM,
  QUOTATION_BILLING_TYPE,
  QUOTATION_CHARGE_UNIT,
  loadQuotationOptions,
} from '@/utils/quotationOptions';
import {
  QUOTATION_CALC_FUEL,
} from '@/utils/constants';
import CostEditorPanel from '../components/CostEditorPanel.vue';

const getDefaultFeeForm = () => ({
  feeItem: null,
  feeItemType: 1,
  billingType: null,
  chargeUnit: null,
  calcFuel: 1,
});

export default {
  name: 'BusinessQuotationCustomerOtherCost',
  components: {
    CostEditorPanel,
  },
  data() {
    return {
      // 费用项 feeItem 0.运费 1.操作费 2.超长附加费 3.托盘费 4.滞期费
      QUOTATION_FEE_ITEM,
      // 计费类型 billingType 0.重量 1.长度 2.托盘 3.票数 4.小时数 5.件数 6.固定值
      QUOTATION_BILLING_TYPE,
      // 计费单位 chargeUnit 0.公斤 1.厘米 2.托 3.票 4.小时 5.件 6.次
      QUOTATION_CHARGE_UNIT,
      // 计算燃油 calcFuel 0.是 1.否
      QUOTATION_CALC_FUEL,
      feeItems: [],
      activeFeeKey: '',
      feeDialogVisible: false,
      formTitle: this.$t('addText'),
      feeForm: getDefaultFeeForm(),
    };
  },
  computed: {
    activeFeeItem() {
      return this.feeItems.find((item) => this.getFeeCardKey(item) === this.activeFeeKey) || null;
    },
    feeItemOptions() {
      return QUOTATION_FEE_ITEM.map(item => ({
        ...item,
        disabled: String(item.value) === '0',
      }));
    },
    feeFormRules() {
      return {
        feeItem: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        billingType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        chargeUnit: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        calcFuel: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      };
    },
  },
  created() {
    loadQuotationOptions();
    // 获取报价详情
    this.getCardData();
  },
  methods: {
    selectFeeItem(item) {
      this.activeFeeKey = this.getFeeCardKey(item);
    },
    getFeeCardKey(item) {
      if (!item) return '';
      return item.id || `${item.supplierLogisticsQuoteId || ''}-${item.feeItem}-${item.feeItemType}-${item.billingType}`;
    },
    getBaseFeeForm() {
      return {
        ...getDefaultFeeForm(),
        supplierLogisticsQuoteId: this.$route.query.id,
      };
    },
    handleBillingTypeChange(value) {
      const billingType = value !== undefined ? value : this.feeForm.billingType;
      this.feeForm.chargeUnit = billingType === '' || billingType === null || billingType === undefined ? null : Number(billingType);
      this.$nextTick(() => {
        this.$refs.feeForm && this.$refs.feeForm.clearValidate('chargeUnit');
      });
    },
    normalizeFeeCardList(res) {
      const list = Array.isArray(res) ? res : (res ? [res] : []);
      return list.filter((item) => item && String(item.feeItemType) === '1');
    },
    getCardData() {
      logisticApi.getFeeTypeCardData({ id: this.$route.query.id }).then((res) => {
        // 提取 feeItemType 为 1 的所有数据
        this.feeItems = this.normalizeFeeCardList(res);
        if (!this.feeItems.some((item) => this.getFeeCardKey(item) === this.activeFeeKey)) {
          this.activeFeeKey = this.feeItems.length ? this.getFeeCardKey(this.feeItems[0]) : '';
        }
      });
    },
    // 新增、编辑 费用项卡片
    openFeeDialog(item) {
      this.formTitle = item ? this.$t('editText') : this.$t('addText');
      this.feeForm = item ? JSON.parse(JSON.stringify(item)) : this.getBaseFeeForm();
      this.feeDialogVisible = true;
      this.clearFeeFormValidate();
    },
    // 提交费用项卡片表单
    confirmFeeDialog() {
      this.$refs.feeForm.validate((valid) => {
        if (!valid) return this.$scrollToFormError();
        if (!this.feeForm.id) {
          // 新增
          logisticApi.addFeeTypeCardData(this.feeForm).then((res) => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              // 保存成功后关闭对话框并刷新卡片列表
              this.closeFeeDialog();
              this.getCardData();
            }
          });
        } else {
          // 编辑
          logisticApi.updateFeeTypeCardData(this.feeForm).then((res) => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              // 保存成功后关闭对话框并刷新卡片列表
              this.closeFeeDialog();
              this.getCardData();
            }
          });
        }
      });
    },
    // 删除费用项卡片
    deleteFeeItem(item) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('okText'),
        cancelButtonText: this.$t('cancelText'),
        type: 'warning',
      })
        .then(() => {
          logisticApi.deleteFeeTypeCardData({ ids: [item.id] }).then((res) => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.getCardData();
            }
          });
        });
    },
    closeFeeDialog() {
      this.feeDialogVisible = false;
      this.feeForm = getDefaultFeeForm();
      this.clearFeeFormValidate();
    },
    clearFeeFormValidate() {
      this.$nextTick(() => {
        this.$refs.feeForm && this.$refs.feeForm.clearValidate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.other-cost-page {
  height: calc(100vh - 78px);
  overflow: hidden;
  box-sizing: border-box;
  background: #f3f6fa;
  color: #1f2d3d;
}

.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 22px;
  background: #ffffff;
  border-bottom: 1px solid #e5e9f0;
}

.page-head h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.workbench {
  display: grid;
  grid-template-columns: 278px minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  gap: 24px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 22px 30px;
}

.workbench > * {
  min-height: 0;
  min-width: 0;
}

.fee-sidebar {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 0;
  padding: 0px 5px;
}

.fee-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 8px;
  scrollbar-color: #082dc3 #eef2f7;
  scrollbar-width: thin;
}

.fee-list::-webkit-scrollbar {
  width: 6px;
}

.fee-list::-webkit-scrollbar-track {
  background: #eef2f7;
  border-radius: 999px;
}

.fee-list::-webkit-scrollbar-thumb {
  background: #082dc3;
  border-radius: 999px;
}

.fee-list::-webkit-scrollbar-thumb:hover {
  background: #0851c0;
}

.fee-card,
.add-fee-card {
  background: #ffffff;
  border: 1px solid #e1e7ef;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
}

.fee-card {
  position: relative;
  padding: 10px 10px 10px;
  cursor: pointer;
}

.fee-card.active {
  border: 2px solid #082dc3;
  box-shadow: 0 8px 20px rgba(8, 45, 195, 0.13);
}

.fee-card h3 {
  margin: 0;
  color: #132238;
  font-size: 18px;
  line-height: 1.2;
}

.fee-card-main {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
}

.fee-title-row {
  width: 100%;
  text-align: center;
  overflow-wrap: anywhere;
}

.fee-meta-side {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.fee-meta-side.centered {
  align-items: stretch;
}

.fee-meta {
  display: grid;
  grid-template-columns: minmax(0, 1fr) max-content;
  align-items: center;
  column-gap: 8px;
  margin-bottom: 0;
  font-size: 12px;
  min-width: 0;
}

.meta-label {
  min-width: 0;
  color: #4b5563;
  text-align: left;
  line-height: 1.2;
  white-space: normal;
  word-break: normal;
  overflow-wrap: normal;
}

::v-deep .fee-meta .el-tag {
  max-width: 106px;
  height: auto;
  min-height: 20px;
  padding: 0 4px;
  text-align: center;
  white-space: normal;
  word-break: normal;
  overflow-wrap: normal;
}

::v-deep .fee-meta .el-switch {
  flex: 0 0 auto;
  transform: scale(0.72);
  transform-origin: center center;
}

.fee-actions {
  display: flex;
  justify-content: space-between;
  padding-top: 6px;
  margin-top: 6px;
  border-top: 1px dashed #e5e7eb;
}

.danger-text {
  color: #f04438;
}

.add-fee-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 92px;
  color: #8a94a6;
  border-style: dashed;
  cursor: pointer;
}

.add-fee-card i {
  margin-bottom: 8px;
  font-size: 26px;
}

::v-deep .fee-form .el-select,
::v-deep .fee-form .el-input {
  width: 100%;
}

@media (max-width: 1100px) {
  .workbench {
    grid-template-columns: 1fr;
  }
}
</style>
